module.exports = __webpack_public_path__ + "static/img/Rectangle-10.6e27db9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/Rectangle-10.png
// module id = NMge
// module chunks = 0